import React from "react";
import TripSummaryContainer from "../../containers/TransportationContainer/TripSummaryContainer";

const TripSummaryPage = () => {
  return <TripSummaryContainer />;
};
export default TripSummaryPage;
